/* eslint-disable camelcase */
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { storeActive as activeStoreSelector, isPartnerStore } from 'ggApp/modules/store/selectors';
import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';
import {
    businessStoreDealsFlag,
    businessRequestOfferFlag,
} from 'ggApp/modules/featureFlag/selectors';

import PageLinks from './PageLinks';

const enhance = compose(
    withDeviceInfo,
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            isPartner: isPartnerStore,
            businessStoreDealsEnabled: businessStoreDealsFlag,
            requestOfferEnabled: businessRequestOfferFlag,
        }),
    ),
    withProps(({ userDevice, activeStore: { country_code, code, activeLanguage } }) => ({
        isDesktopUser: userDevice !== 'mobile' && userDevice !== 'tablet',
        isBusinessStore: code.startsWith('business'),
        storeCode: code,
        countryCode: country_code.toLowerCase(),
        activeLanguage,
    })),
);

export default enhance(PageLinks);
